// Supported languages for the site.
// `code`      -> i18next language key (used in URLs: /zh/...)
// `htmlLang`  -> value for <html lang="..."> and hreflang
// `label`     -> text shown in the language switcher
// `dir`       -> text direction (all current languages are LTR)
export const LANGUAGES = [
    { code: 'en', htmlLang: 'en', label: 'English', short: 'EN', dir: 'ltr' },
    { code: 'zh', htmlLang: 'zh-CN', label: '中文', short: '中文', dir: 'ltr' },
    { code: 'tr', htmlLang: 'tr', label: 'Türkçe', short: 'TR', dir: 'ltr' },
];

export const DEFAULT_LANGUAGE = 'en';

// Languages that get a URL prefix (everything except the default).
export const PREFIXED_LANGUAGES = LANGUAGES
    .map((l) => l.code)
    .filter((code) => code !== DEFAULT_LANGUAGE);

export const SUPPORTED_LANGUAGE_CODES = LANGUAGES.map((l) => l.code);

export const getLanguageMeta = (code) =>
    LANGUAGES.find((l) => l.code === code) || LANGUAGES[0];
